/**
 * Google Analytics Helper
 */
import ReactGA from 'react-ga4';

/**
 * Remove empty attributes from an object
 */
function removeEmpty(obj) {
  return Object.fromEntries(Object.entries(obj).filter(([_, v]) => v != null));
}

/**
 * Send a Custom Event to Google Analytics
 */
export function gaEvent({
  category = null,
  action = null,
  label = null, // optional
  value = null, // optional, must be a number
  nonInteraction = null, // optional, true/false
  transport = null, // optional, beacon/xhr/image
}, send = true) {
  if (!category) {
    console.error('Analytics: category is required to send an event');
    return;
  }

  if (!action) {
    console.error('Analytics: action is required to send an event');
    return;
  }

  if (!send) {
    console.error('Analytics: event cancelled, send parameter is false');
  }

  const data = removeEmpty({
    category,
    // action is sent as the first parameter instead
    // this is so the react-ga4 library doesn't automatically capitalize the first letter of the action
    // action,
    label,
    value,
    nonInteraction,
    transport,
  });

  console.log('Analytics Event:', action, data);

  // send custom event
  ReactGA.event(action, data);
}

export default {
  gaEvent,
};